<template>
        <!-- Area editor dialog -->
        <div class="nopads" style="overflow: visible">
            <span class="span-title">{{ $t('areas.area_name') }}</span>
            <input
                id="areaName"
                v-model="newAreaName"
                class="form-control form-control-md"
                type="text"
                autofocus
                :placeholder="$t('areas.area_name')"
            />
            <span class="span-title">{{ $t('areas.type') }}</span>
            <select
                v-model="selectedAreaType"
                class="form-select form-select-md"
            >
                <option :value="null">
                    {{ $t('areas.select_area_type') }}
                </option>

                <option
                    v-for="item in areaTypes"
                    :key="item.value"
                    :value="item.value"
                >
                    {{ item.text }}
                </option>
            </select>
            <span class="span-title">{{ $t('areas.square_meters') }}</span>
            <input
                id="areaName"
                class="form-control form-control-md"
                v-model="newAreaSqm"
                type="number"
                step="any"
            />
            <span class="span-title">{{ $t('tasktypes.color') }}</span>
            <color-picker
                @selectColor="(color) => setColor(color)"
                :default-color="selectedColor"
            />
            <span
                v-if="editMode"
                class="span-title"
            >{{ $t('areas.inactivate_area') }}</span>
            <div
                v-if="editMode"
                class="title"
            >
                <div class="form-check form-switch mt-1">
                    <input
                        type="checkbox"
                        id="isInactive"
                        class="form-check-input form-check-mb"
                        v-model="isInactive"
                    />
                </div>
            </div>
            <div class="button-container top-margin">
                <button
                    class="btn btn-lg btn-success"
                    :disabled="!newAreaName || !selectedAreaType"
                    @click.stop="submitArea"
                >
                    <span class="map-button-text">{{ $t('areas.save_area') }}</span>
                </button>
            </div>
        </div>
</template>

<script>

import ColorPicker from "@/components/ColorPicker";
export default {
    name: 'AreaSaveDialog',
    components: {ColorPicker},
    data: function () {
        return {
            newAreaName: null,
            newAreaSqm: null,
            calculatedArea: null,
            isInactive: false,
            selectedAreaType: null,
            selectedColor: "#007bff",
        }
    },
    props: {
        area: {
            type: Object,
            default: null
        },
        calclatedSqm: {
            type: Number,
            default: null
        },
        areaTypes: {
            type: Array,
            default() {
                return []
            }
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    created: function () {
        if (this.area) {
            this.newAreaName = this.area.name
            this.selectedColor = this.area.color
            this.selectedAreaType = this.area.type.id
            this.newAreaSqm = this.area.square_meters
            this.isInactive = this.area.is_inactive
        } else if (this.calclatedSqm) {
            this.newAreaSqm = Math.round(this.calclatedSqm)
        }
    },
    methods: {
        submitArea: function () {
            this.$emit('save', this.newAreaName, this.selectedAreaType, this.newAreaSqm, this.selectedColor, this.isInactive)
        },

        setColor(color) {
            this.selectedColor = color
        }
    }
}
</script>

<style scoped>

</style>
